window.vermoegenswertTodesfallschutz = {
	data: new Map(),

	versicherungssumme_risiko: function () {
		return this.highchartWerte("versicherungssumme_risiko")
	},

	versicherungssumme_todesfallschutz: function () {
		return this.highchartWerte("versicherungssumme_todesfallschutz")
	},

	beitrag_risiko: function () {
		return this.highchartWerte("beitrag_risiko")
	},

	beitrag_todesfallschutz: function () {
		return this.highchartWerte("beitrag_todesfallschutz")
	},

	// PRIVATE
	highchartWerte: function (kategorie) {
		const result = []
		this.data.forEach((value, key) => result.push([key, value[kategorie]]))

		return result
	},
}

window.todesfallschutzChart = {
	init: function () {
		this.chart = new Highcharts.stockChart("chart_todesfallschutz", {
			yAxis: [
				{},
				{
					opposite: true,
				},
			],

			legend: {
				enabled: true,
			},

			plotOptions: {
				area: {
					stacking: "normal",
				},
			},

			series: this.chartdata(),
		})
	},

	update: function (chartdata) {
		if (typeof this.chart !== "undefined") {
			this.chart.showLoading()

			this.chartdata().forEach(
				function (serie) {
					this.chart.get(serie.id).setData(serie.data, false)
				}.bind(this)
			)

			this.chart.redraw({ duration: chartAnimationDuration })
			this.chart.hideLoading()
		}
	},

	chartdata: () => {
		return [
			{
				name: "Todesfallschutz",
				id: "versicherungssumme_todesfallschutz",
				legendName: "Gesamte Versicherungsleistung",
				yAxis: 0,
				type: "area",
				color: farbeLeistung,
				opacity: "0.5",
				zIndex: 0,
				data: vermoegenswertTodesfallschutz.versicherungssumme_todesfallschutz(),
			},
			{
				name: "Risikolebensversicherung",
				id: "versicherungssumme_risiko",
				legendName: "Gesamte Versicherungsleistung",
				yAxis: 0,
				type: "area",
				color: farbeLeistung,
				opacity: "0.5",
				zIndex: 0,
				linkedTo: "versicherungssumme_todesfallschutz",
				data: vermoegenswertTodesfallschutz.versicherungssumme_risiko(),
			},
			{
				name: "Beitrag zur Risikolebensversicherung",
				id: "beitrag_risiko",
				legendName: "Beitrag zur Risikolebensversicherung",
				yAxis: 1,
				type: "column",
				color: farbeBeitrag1,
				zIndex: 1,
				data: vermoegenswertTodesfallschutz.beitrag_risiko(),
			},
			{
				name: "Beitrag zum Todesfallschutz",
				id: "beitrag_todesfallschutz",
				legendName: "Beitrag zum Todesfallschutz",
				yAxis: 1,
				type: "column",
				color: farbeBeitrag1,
				zIndex: 1,
				data: vermoegenswertTodesfallschutz.beitrag_todesfallschutz(),
			},
		]
	},
}
